import React from 'react';

import { flagStyles } from '../settings';

const SvgSL = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-4824px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgSL;
